import { Clock, CheckCircle2, FileDiff, AlertTriangle } from "lucide-react";

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};

export const RECON_META = {
  awaiting: { label: "Awaiting Payment", tone: "slate", Icon: Clock },
  matched: { label: "Matched", tone: "green", Icon: CheckCircle2 },
  difference: { label: "Difference Detected", tone: "amber", Icon: FileDiff },
  needs_review: { label: "Needs Review", tone: "indigo", Icon: AlertTriangle },
  reconciled: { label: "Reviewed / Reconciled", tone: "green", Icon: CheckCircle2 },
};

export const RECON_ORDER = ["awaiting", "matched", "difference", "needs_review", "reconciled"];

export function ReconBadge({ status, testId }) {
  const meta = RECON_META[status] || RECON_META.awaiting;
  const { Icon } = meta;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${TONES[meta.tone]}`}>
      <Icon size={13} strokeWidth={2.4} />
      {meta.label}
    </span>
  );
}

export function isPaid(report) {
  return report?.actual_cents != null;
}

export function PaidBadge({ report, testId }) {
  const paid = isPaid(report);
  const recon = RECON_META[report?.reconciliation_status];
  const label = paid ? (recon ? `Paid · ${recon.label}` : "Paid") : "Unpaid";
  const tone = paid ? (report?.reconciliation_status === "difference" || report?.reconciliation_status === "needs_review" ? "amber" : "green") : "indigo";
  return (
    <span data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${TONES[tone]}`}>
      {paid ? <CheckCircle2 size={13} strokeWidth={2.4} /> : <Clock size={13} strokeWidth={2.4} />}
      {label}
    </span>
  );
}
